import { Button, DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutManualOpenItemProcessing extends Layout {
    processLogButton: Button;
    searchpanelManualOpenItemProcessing: SearchPanel;
    sourceOpenItemManual: DataSource;
    tableManualOpenItems: Table;
    textboxAmount: Textbox;
    textboxBillDate: Textbox;
    textboxCurrencyType: Textbox;
    textboxCustomerIdSearch: Textbox;
    textboxDepositNumber: Textbox;
    textboxGlDate: Textbox;
    textboxInvoiceNumber: Textbox;
    textboxOrderId: Textbox;
    textboxRecordType: Textbox;
    textboxReferenceNumber: Textbox;
    textboxShipDate: Textbox;
}
